import React from 'react';
import openWindow from '@/script/openWindow.mjs';
import Keyword from './Keyword.jsx';
import cssTable from './SearchTable';
import Table from '@/biz/Table.jsx';

const Pane = ({ param, nodeType, dataList, rows, setRows, loading }) => {
    const keyword = param.current.keyword;
    const prjPatternId = param.current.prjPatternId;
    const patternRev = param.current.patternRev;

    const onLink = (record) => {
        const mapInits = {
            selectedNodes: [{ path: record.mapPath }],
        }

        if (record.mapVerId) {
            const inits = { ...mapInits };
            openWindow('/SoftwareMap', { id: record.mapVerId, mode: 'snapshot', inits, prjPatternId, patternRev });
        } else {
            if ('LS' == nodeType) {
                openWindow('/LsDetail', { lsId: record.dpId, mapInits });
            } else {
                openWindow('/SoftwareMap', { id: record.dpId, inits: mapInits });
            }
        }
    }

    const columns = [
        ('PM' == nodeType) && {
            key: 'pmNamePath',
            dataIndex: 'pmNamePath',
            title: '流程域',
            width: '150px',
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        ('BM' == nodeType) && {
            key: 'bmNamePath',
            dataIndex: 'bmNamePath',
            title: '业务域',
            width: '150px',
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        ('DM' == nodeType) && {
            key: 'dmNamePath',
            dataIndex: 'dmNamePath',
            title: '数据域',
            width: '150px',
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        ('FM' == nodeType) && {
            key: 'fmNamePath',
            dataIndex: 'fmNamePath',
            title: '功能域',
            width: '150px',
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        ('UM' == nodeType) && {
            key: 'umNamePath',
            dataIndex: 'umNamePath',
            title: '界面模块',
            width: '150px',
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        ('VM' == nodeType) && {
            key: 'vmNamePath',
            dataIndex: 'vmNamePath',
            title: '程序域',
            width: '150px',
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        ('CM' == nodeType) && {
            key: 'cmNamePath',
            dataIndex: 'cmNamePath',
            title: '用例域',
            width: '150px',
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        ('LS' == nodeType) && {
            key: 'lsName',
            dataIndex: 'lsName',
            title: '外联系统',
            width: '150px',
            ellipsis: true,
            filter: <Table.FilterText />,
        },
        {
            key: 'keywordPath',
            dataIndex: 'keywordPath',
            title: '节点',
            ellipsis: true,
            filter: <Table.FilterText />,
            onCell: (record, index) => {
                return { style: { whiteSpace: 'wrap' } };
            },
            render: (text, record) => {
                record.mapPath = record.keywordEncodePath;
                return <a onClick={() => onLink(record)}><Keyword data={text.substr(0, text.length - 1)} keyword={keyword} /></a>;
            }
        }
    ].filter(v => v);

    const rowSelection = {
        selectedRowKeys: rows.map(({ pkid }) => pkid),
        onChange: (selectedRowKeys, selectedRows) => {
            setRows(selectedRows);
        },
    }

    return (
        <Table
            code="map-search"
            size="small"
            loading={loading}
            columns={columns}
            dataSource={dataList}
            css={cssTable}
            rowKey={"pkid"}
            rowSelection={{ type: "checkbox", ...rowSelection }}
        />
    );
}

export default Pane;
